import * as tslib_1 from "tslib";
import { ChangeDetectorRef, OnChanges, OnInit, SimpleChanges, } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AppStateFacade } from '@app-state';
import { UiSettingForm } from '@components/ui-forms/ui-setting-form';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService, SettingService, } from '@services';
import { UiSnackBarService } from '@uipath/angular/components/ui-snackbar';
import { of, } from 'rxjs';
var UiGeneralSettingsComponent = /** @class */ (function (_super) {
    tslib_1.__extends(UiGeneralSettingsComponent, _super);
    function UiGeneralSettingsComponent(settingService, _cd, _fb, _translateService, _languageService, _snack, appState) {
        var _this = _super.call(this, _cd, appState) || this;
        _this.settingService = settingService;
        _this._cd = _cd;
        _this._fb = _fb;
        _this._translateService = _translateService;
        _this._languageService = _languageService;
        _this._snack = _snack;
        _this.authConfig$ = appState.authConfig.value$;
        return _this;
    }
    UiGeneralSettingsComponent.prototype.ngOnInit = function () {
        if (this.showConnectionString) {
            this.connectionString$ = this.settingService.getConnectionString();
        }
        this.formGroup = this._fb.group({
            'timezone': [[]],
            'language': [[]],
            'isModernFolderSystemEnabled': [this.settings.general.isModernFolderSystemEnabled],
        });
    };
    UiGeneralSettingsComponent.prototype.ngOnChanges = function (changes) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d;
            var _this = this;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _super.prototype.ngOnChanges.call(this, changes);
                        if (!changes.settings) return [3 /*break*/, 5];
                        _a = this;
                        _b = this.timezones;
                        if (_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.settingService.getTimezones().toPromise()];
                    case 1:
                        _b = (_e.sent()).map(function (tz) {
                            return {
                                id: tz.Value,
                                text: tz.Name,
                            };
                        });
                        _e.label = 2;
                    case 2:
                        _a.timezones = _b;
                        this.formGroup.get('timezone').patchValue((this.timezones || []).filter(function (tz) { return tz.id === _this.settings.general.timezone; }));
                        _c = this;
                        _d = this.languages;
                        if (_d) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._languageService.getAll().toPromise()];
                    case 3:
                        _d = (_e.sent()).map(function (lang) {
                            return {
                                id: lang.Name,
                                text: lang.DisplayName,
                                icon: {
                                    iconOnly: lang.Name === 'ja',
                                    svgIcon: lang.Name === 'ja' ? 'uipath:language_ja' : undefined,
                                },
                            };
                        });
                        _e.label = 4;
                    case 4:
                        _c.languages = _d;
                        this.formGroup.get('language').patchValue((this.languages || []).filter(function (lang) { return lang.id === _this.settings.general.language; }));
                        this._cd.markForCheck();
                        _e.label = 5;
                    case 5:
                        if (changes.showConnectionString != null) {
                            this.connectionString$ = changes.showConnectionString.currentValue ?
                                this.settingService.getConnectionString() :
                                of('');
                            this._cd.markForCheck();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    UiGeneralSettingsComponent.prototype.onClipboardCopy = function () {
        this._snack.success(this._translateService.instant('settings_general_form_connection_string_copy_message'));
    };
    return UiGeneralSettingsComponent;
}(UiSettingForm));
export { UiGeneralSettingsComponent };
